var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4A4A4F",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 487.048 487.048",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icons_14_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.723,293.718H16.733c-9.252,0-16.733,7.49-16.733,16.73c0,9.239,7.481,16.731,16.733,16.731h136.99 c9.245,0,16.729-7.492,16.729-16.731C170.452,301.208,162.968,293.718,153.723,293.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.452,226.79H66.926c-9.248,0-16.732,7.492-16.732,16.733c0,9.239,7.484,16.731,16.732,16.731h103.525 c9.25,0,16.734-7.492,16.734-16.731C187.186,234.281,179.702,226.79,170.452,226.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.919,176.594c0-9.238-7.483-16.731-16.732-16.731h-70.063c-9.252,0-16.734,7.493-16.734,16.731 c0,9.241,7.482,16.733,16.734,16.733h70.063C196.435,193.328,203.919,185.836,203.919,176.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.458,132.281c-6.801-7.956-16.699-12.514-27.178-12.514H259.455c-17.729,0-32.582,12.711-35.345,30.244 l-27.513,176.011c-1.599,10.325,1.374,20.8,8.167,28.741c6.801,7.956,16.699,12.517,27.178,12.517h191.826 c17.73,0,32.58-12.714,35.344-30.247l27.512-176.008C488.223,150.697,485.253,140.222,478.458,132.281z M426.038,331.854 c-0.178,1.135-1.13,1.961-2.27,1.961H231.942c-0.672,0-1.309-0.301-1.75-0.803c-0.439-0.512-0.62-1.198-0.521-1.853 l27.514-175.97c0.18-1.136,1.129-1.961,2.271-1.961h61.831l-8.04,43.295c-0.608,3.267,0.26,6.64,2.396,9.198 c2.127,2.566,5.283,4.043,8.613,4.043h38.908c5.393,0,10.03-3.846,11.01-9.148l8.811-47.386h68.295 c0.672,0,1.311,0.304,1.75,0.802c0.439,0.516,0.619,1.202,0.521,1.854L426.038,331.854z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectOne);
export default __webpack_public_path__ + "static/media/directOne.4e287a6c313d83e8d792304f5f6cebf6.svg";
export { ForwardRef as ReactComponent };